export const FORUM_PAGE_DESCRIPTION =
  'Participa en debates académicos con tus compañeros y docentes de forma anónima.';

export const FORUM_STAFF_PAGE_DESCRIPTION =
  'Foro de discusión del curso para dudas, recursos y debates entre estudiantes y docentes.';
